import { ConfigurationEntry } from "@/model/communication/application/GetServerConfigurationResponse";
import { ApplicationStartupData } from "@/model/communication/application/StartupData";
import { ModelInfo } from "@/model/communication/supportObjects/ModelInfo";
import { Branch } from "@/model/data/Branch";
import { Denomination } from "@/model/data/Denomination";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { TagValues } from "@/model/data/Tag";
import { SoftwareFilter } from "@/model/data/updates/SoftwareFilter";
import { RootState } from "@/store";
import { Module } from "vuex";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export class ApplicationState {
    applicationLoaded: boolean;

    drawer: any;

    supportedModels: ModelInfo[];
    startupData: ApplicationStartupData = new ApplicationStartupData();
    tvMode: boolean = false;
    configurationEntries: ConfigurationEntry[] = [];

    // Available data for filters
    availableBranches: Branch[];
    availableBranchesIncludeEmpty: Branch[];
    availableBranchesIncludeDeleted: Branch[];
    availableMachineModels: Map<LicenseModuleEnum, string[]>;
    availableSoftwareVersions: SoftwareFilter[];
    availableSoftwareVersionsFetching: boolean;
    availableSoftwareVersionsType: string;
    availableTags: TagValues[];
    modelTree: string;

    //Denominations
    allDenominations: Denomination[];

    // Application events
    openDeviceTreeToFolderIdEvent: -1;

    isCloud: boolean = false;

    constructor() {
        this.applicationLoaded = false;
        this.drawer = null;
        this.supportedModels = [];
        this.availableBranches = [];
        this.availableBranchesIncludeEmpty = [];
        this.availableBranchesIncludeDeleted = [];
        this.availableMachineModels = null;
        this.availableSoftwareVersions = [];
        this.availableSoftwareVersionsFetching = false;
        this.availableSoftwareVersionsType = "";
        this.availableTags = null;
        this.allDenominations = null;
        this.openDeviceTreeToFolderIdEvent = -1;
        this.modelTree = "";
        this.isCloud = window.location.href.includes("cimaspa.com") && !window.location.href.includes("nedbank") && !window.location.href.includes("loomis");
    }
}

export default {
    state: new ApplicationState(),
    mutations,
    actions,
    getters,
} as Module<ApplicationState, RootState>;
